export const color = {
  offWhite: "#F9F9F9",
  black: "#000000",
  white: "#FFFFFF",
  lightGreen: "#25D5A1",
  darkGreen: "#00473E",
  gray: "#71717A",
  red: "#ED4A71",
  lightGrey: "#EAECF0",
  darkGrey: "#979797",
};
